// Copyright (C) 2022 Cochise Ruhulessin
//
// All rights reserved. No warranty, explicit or implicit, provided. In
// no event shall the author(s) be liable for any claim or damages.
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
import useWindowDimensions from "./useWindowDimensions"


const ScreenSizeConditional: React.FC<{children: React.ReactNode, full?: boolean}> = ({
  children,
  full
}) => {
  const {width, height} = useWindowDimensions()
  const isFullSize: boolean = (width > 768) && (width > height) || (height > 1024)
  if (!full && isFullSize) { return null }
  if (!!full && !isFullSize) { return null }

  return (<>{children}</>)
}

export { ScreenSizeConditional }